import styled from 'styled-components'

import { visuallyHidden } from '@/lib/themes/mixins'

export const BASE_RADIO_HEIGHT = '24px'

export const StyledWrapper = styled.div`
  margin-bottom: 12px;
`

export const StyledRadio = styled.input`
  ${visuallyHidden};
`

export const StyledLabel = styled.label`
  position: relative;
  display: block;
  min-height: ${BASE_RADIO_HEIGHT};
  padding: 0 0 0 ${({ theme: { layout } }) => layout.spacing(4)};
  font-size: ${({ theme: { fontSize } }) => fontSize.default};
  line-height: ${BASE_RADIO_HEIGHT};
  cursor: pointer;

  &:focus {
    outline: ${({ theme: { outline } }) => outline.border};
    outline-offset: ${({ theme: { outline } }) => outline.offset};
  }
`
